import { SetupCall } from '@driscollsinc/driscolls-display-rules';
import { LOOKUP_FIELDS } from '../constants';
import { lookupSetupFields } from './CommonSetupFields';

function configureSetupCall() {
    SetupCall(
        LOOKUP_FIELDS.UOMLookUp,
        [...lookupSetupFields],
        {}, //options
        (data) => {
            console.log('UOMLookUp REDUCER-- ', data);
        }
    );
}

const UOMLookUp = {
    configureSetupCall
};

export default UOMLookUp;
